
import axios from "axios";
import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;


export async function GetCelebration(params) {
    try {
      const headers = await getHeaders();
      const response = await axiosInstance.post(`${baseURL}/Employee/Celebrations`, params, { headers });
      return checkStatus(response);
    } catch (error) {
      return error;
    }
  }